export default __webpack_public_path__ + "static/media/AlertIcon.b7ee67da.svg";